var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"repo-label-item",style:({
    'background-color': '#' + _vm.label?.hexColor
  })},[_c('span',{directives:[{name:"truncate-text",rawName:"v-truncate-text",value:({
      mediaValue: {
        sm: 30,
        md: 30,
        lg: 30,
        xl: 30,
        coefficient: 100,
        base: _vm.label?.title?.length
      },
      originalText: _vm.label?.title
    }),expression:"{\n      mediaValue: {\n        sm: 30,\n        md: 30,\n        lg: 30,\n        xl: 30,\n        coefficient: 100,\n        base: label?.title?.length\n      },\n      originalText: label?.title\n    }"}],staticClass:"gf-adaptate-color repo-list-label"},[_vm._v(" "+_vm._s(_vm.label?.title)+" ")]),(_vm.deletable)?_c('i',{staticClass:"gf-icon gf-icon-x gf-adaptate-color repo-list-icon",on:{"click":function($event){return _vm.$emit('delete', _vm.label)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }